import { render } from "./Visit.vue?vue&type=template&id=95c8d170&ts=true"
import script from "./Visit.vue?vue&type=script&lang=ts"
export * from "./Visit.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__